<template>
    <material-card color="primary" text="" xs12>
        <template>
            <v-btn :flat="!filtrarPremiumTeste" color="primary" small @click="pagina = 1; filtrarPremiumTeste = !filtrarPremiumTeste; recarregaUsers();">
                Premium Teste
            </v-btn>
            <v-btn :flat="!filtrarPremium" color="primary" small @click="pagina = 1; filtrarPremium = !filtrarPremium; recarregaUsers();">
                Premium
            </v-btn>
            <v-btn :flat="!filtrarPremiumVencido" color="primary" small @click="pagina = 1; filtrarPremiumVencido = !filtrarPremiumVencido; recarregaUsers();">
                Premium Vencido
            </v-btn>
            <v-btn :flat="!filtrarPlanoVencendo" color="primary" small @click="pagina = 1; filtrarPlanoVencendo = !filtrarPlanoVencendo; recarregaUsers();">
                Premium Vencendo
            </v-btn>
            <v-btn :flat="!filtrarConsultoria" color="primary" small @click="pagina = 1; filtrarConsultoria = !filtrarConsultoria; recarregaUsers();">
                Consultor
            </v-btn>
            <v-btn :flat="!filtrarPecuarista" color="primary" small @click="pagina = 1; filtrarPecuarista = !filtrarPecuarista; recarregaUsers();">
                Pecuarista
            </v-btn>
            <v-btn :flat="!filtrarVinculados" color="primary" small @click="pagina = 1; filtrarVinculados = !filtrarVinculados; recarregaUsers();">
                Vinculados
            </v-btn>
            <v-btn :flat="!filtrarAdmin" color="primary" small @click="pagina = 1; filtrarAdmin = !filtrarAdmin; recarregaUsers();">
                Adm
            </v-btn>
            <v-btn :flat="!filtrarInativos" color="primary" small @click="pagina = 1; filtrarInativos = !filtrarInativos; recarregaUsers();">
                Inativos
            </v-btn>
        </template>
        <v-sheet class="pa-3 primary">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                        v-model="searchUsers"
                        :label="strings[idioma].usuarios"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        append-icon="mdi-magnify"
                        clear-icon="mdi-close"
                        @keydown="pagina = 1"
                        @click="pagina = 1"
                        @change="pagina = 1"
                    />
                </v-flex>
            </v-layout>
        </v-sheet>
        <div class="blue mx-auto py-2 white--text pr-2 pl-2" style="width: 100%;">Foram encontrados {{ countResultados }} usuários</div>
        <div style="max-height: 300px; overflow: auto;">
            <v-card v-if="loadingUsers">
                <v-layout :style="{'height': heightCard}" column fill-height justify-center align-center>
                    <v-progress-circular :size="50" color="primary" indeterminate> </v-progress-circular>
                </v-layout>
            </v-card>
            <v-card v-else class="mx-auto" style="width: 100%;" tile>
                <v-list v-if="users" dense ripple flat rounded>
                    <div color="primary">
                        <v-list-tile
                            v-for="us in users"
                            :key="us.id"
                            :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                            flat
                            @click="onClick(us)"
                        >
                            <v-list-tile-avatar>
                                <v-icon v-if="us.plano && us.plano.revogado === 1" :color="'orange'" title="Plano revogado" v-text="'mdi-account-alert'" />
                                <v-icon v-else-if="us.EXCLUIDO !== 1" :color="(us.permissao === 0) ? 'red': (us.lido === 0) ? 'green' : 'black'" v-text="'mdi-account'" />
                                <v-icon v-else :color="(us.permissao === 0) ? 'red': ''" v-text="'mdi-account-off'" />
                                <v-icon v-if="us.liberado === 0" :color="'black'" v-text="'mdi-lock'" />
                                <!-- aguardando pagamento -->
                                <v-icon v-else-if="us.plano && us.plano.status === -1" :color="'red'" title="Aguardando Pagamento" v-text="'mdi-timer'" />
                                <!-- aguardando verificação de e-mail -->
                                <v-icon v-else-if="us.permissao === 2" :color="'orange'" title="Aguardando Verificação de E-mail" v-text="'mdi-email-alert'" />
                            </v-list-tile-avatar>
                            <v-list-tile-action>
                                <span :style="(us.lido === 0) ? 'color: green' : 'color: black'">
                                    <v-icon v-if="(us.plano && (us.plano.data_final === null || moment().diff(us.plano.data_final, 'days') <= 0)) || (us.plano === null && us.premium === 1)">mdi-star</v-icon>{{ us.id }}
                                </span>
                            </v-list-tile-action>
                            <v-list-tile-content style="width: 40%;">
                                <v-list-tile-title :style="(us.lido === 0) ? 'color: green' : 'color: black'" class="text-uppercase">
                                    {{ us.NOME }}
                                    <small v-if="us.plano">
                                        - {{ strings[idioma].tempo_de_plano }} ({{ (us.plano.data_inicio) ? moment(us.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '∞' }}, {{ (us.plano.data_final) ?
                                        moment(us.plano.data_final).format(strings[idioma].formato_datas_sem_hora) : '∞' }})
                                        <span v-if="us.plano.valor !== null">- Valor pago: $ {{ us.plano.valor.toFixed(2).replace('.', strings[idioma].separador_float) }} </span>
                                    </small>
                                </v-list-tile-title>
                                <v-list-tile-sub-title :style="(us.lido === 0) ? 'color: green' : 'color: black'">
                                    {{ us.email }}
                                    <small v-if="us.consultoria && !us.consultoria.EXCLUIDO">
                                        - Tempo de Consultor ({{ (us.consultoria.data_inicio) ? moment(us.consultoria.data_inicio).format(strings[idioma].formato_datas_sem_hora) : '∞' }}, {{ (us.consultoria.data_fim) ?
                                        moment(us.consultoria.data_fim).format(strings[idioma].formato_datas_sem_hora) : '∞' }})
                                    </small>
                                    <template v-if="gerenciaPremium">
                                        -
                                        <a flat color="error" small @click="premium = true; tempo_premium = true; userPivot = us">{{ strings[idioma].definir_tempo_premium }}</a>
                                    </template>
                                    <template v-else-if="gerenciaConsultor">
                                        -
                                        <a flat color="error" small @click="consultor = true; tempo_consultor = true; userPivot = us">Definir o tempo de consultor</a>
                                    </template>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <div v-if="gerenciaPremium">
                                    <template v-if="us.premium === 1">
                                        <v-btn flat color="error" @click="premium = true">{{ strings[idioma].revogar_premium }}</v-btn>
                                    </template>
                                </div>
                                <div v-else-if="gerenciaConsultor">
                                    <template v-if="us.consultoria && !us.consultoria.EXCLUIDO">
                                        <v-btn flat color="error" @click="consultoria = true">Revogar Consultoria</v-btn>
                                    </template>
                                </div>
                                <div v-else-if="modoSuperUsuario">
                                    <v-btn :color="'red'" flat @click="excluir = true"><v-icon>mdi-close</v-icon></v-btn>
                                </div>
                                <div v-else>
                                    <v-btn v-if="us.emp_user === null" :color="(us.permissao === 0) ? 'red': (us.lido === 0) ? 'green' : 'black'" flat @click="vincular = true">{{ strings[idioma].vincular }}</v-btn>
                                    <span v-else><a @click="vincular = true">{{ strings[idioma].vinculado_a.format(us.empresa_vinculada[0].nome) }} </a></span>
                                </div>
                            </v-list-tile-action>
                        </v-list-tile>
                    </div>
                </v-list>
            </v-card>
        </div>
        <template>
            <div class="text-xs-center">
                <v-layout align-start justify-space-around wrap justify-center center>
                    <v-flex md12>
                        <v-pagination v-model="pagina" :length="paginaTotal" :total-visible="limit" circle />
                    </v-flex>
                </v-layout>
            </div>
        </template>
        <div v-if="!gerenciaPremium && !gerenciaConsultor">
            <v-btn small flat href="/adm/user/new">
                <v-icon>mdi-plus</v-icon>
                &nbsp; {{ strings[idioma].add_novo_usuario }}
            </v-btn>
            <v-btn small flat @click="gerenciaPremium = true">
                <v-icon>mdi-star</v-icon>
                &nbsp; {{ strings[idioma].gerenciar_premium }}
            </v-btn>
            <v-btn small flat color="error" @click="modoSuperUsuario = !modoSuperUsuario">
                <v-icon>mdi-account</v-icon>
                &nbsp; {{ !modoSuperUsuario ? 'Ativar Super Usuário' : 'Desativar Super Usuário' }}
            </v-btn>
        </div>
        <div v-else>
            <v-btn small flat @click="gerenciaPremium = gerenciaConsultor = false">
                <v-icon>mdi-back</v-icon>
                &nbsp; {{ strings[idioma].voltar }}
            </v-btn>
        </div>
    </material-card>
</template>
<script>
import { mapState } from 'vuex';

export default {
    props: {
        onClick: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            searchUsers: null,
            premium: false,
            tempo_premium: false,
            loading: false,
            loadingUsers: false,
            limit: 7,
            pagina: 1,
            paginaTotal: 1,
            filtrarVinculados: false,
            filtrarConsultoria: false,
            filtrarPecuarista: false,
            filtrarPremium: false,
            filtrarPremiumTeste: false,
            filtrarPremiumVencido: false,
            filtrarPlanoVencendo: false,
            filtrarAdmin: false,
            filtrarInativos: false,
            gerenciaConsultor: false
        }
    },
    computed: {
        ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
        heightCard () {
            return String(this.$vuetify.breakpoint.height - 289) + 'px'
        },
        heightDialog () {
            return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
        },
        heightOverflow () {
            return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
        },
        heightTree () {
            return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
        },
        usersFilter () {
            if (this.searchUsers === null || this.searchUsers.trim() === '') return this.users
            return this.users.filter(u => {
                const reg = new RegExp(replaceSpecialChars(this.searchUsers.toLowerCase()), 'i')
                return reg.test(u.NOME) || reg.test(u.email) || u.id === parseInt(this.searchUsers) || '#' + u.id === this.searchUsers
            })
        }
    },
    watch: {
        searchUsers (val) {
            this.recarregaUsers(val)
        }
    },
    mounted() {
        this.recarregaUsers()
    },
    methods: {
        recarregaUsers (val = null) {
            this.loadingUsers = true
            return this.axios.post('users/get', { limit: this.limit, offset: this.limit * this.pagina, vinculado: this.filtrarVinculados, premium: this.filtrarPremium, premiumVencido: this.filtrarPremiumVencido, consultor: this.filtrarConsultoria, pecuarista: this.filtrarPecuarista, adm: this.filtrarAdmin, premiumTeste: this.filtrarPremiumTeste, inativo: this.filtrarInativos, planoVencendo: this.filtrarPlanoVencendo, search: this.searchUsers }).then(r => {
                this.countResultados = (r.data.data.len > 1) ? r.data.data.len : r.data.data.users.length
                this.users = r.data.data.users
                this.paginaTotal = r.data.data.paginas
                this.queryWork()
            }).catch(() => {
                // this.$router.push('/')
            }).finally(() => {
                this.loadingUsers = false
            })
        }
    }
}
</script>